import SimpleBar from 'simplebar';

// mobile menu init
export default function initSimpleBar() {
  // eslint-disable-next-line no-undef
  const $doc = jQuery(document);
  // detect device type
  // eslint-disable-next-line @stylistic/max-len
  const isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch);

  // eslint-disable-next-line no-undef
  jQuery('.scrolled-table-wrap:has(.scrolled-table)').each((i, wrap) => {
    // eslint-disable-next-line no-undef
    const $wrap = jQuery(wrap);
    const $scrollable = $wrap.find('.scrolled-table');
    const $btnPrev = $wrap.find('.slide-button-prev');
    const $btnNext = $wrap.find('.slide-button-next');
    const simpleBar = new SimpleBar($scrollable[0], {
      autoHide: false,
      clickOnTrack: true,
    });
    const scrollElem = simpleBar.getScrollElement();
    // eslint-disable-next-line no-undef
    const $scrollElem = jQuery(scrollElem);
    let pos = {
      top: 0, left: 0, x: 0, y: 0,
    };

    function mouseMoveHandler(e) {
      const dx = e.clientX - pos.x;

      scrollElem.scrollLeft = pos.left - dx;

      $wrap.addClass('grabbing').removeClass('grab');
    }

    function mouseUpHandler() {
      $doc.off('mousemove', mouseMoveHandler);
      $doc.off('mouseup', mouseUpHandler);

      $wrap.removeClass('grabbing').removeClass('grab');
    }

    function mouseDownHandler(e) {
      pos = {
        left: scrollElem.scrollLeft,
        x: e.clientX,
      };

      $wrap.addClass('grab');

      $doc.on('mousemove', mouseMoveHandler);
      $doc.on('mouseup', mouseUpHandler);
    }

    function scrollHandler() {
      $btnPrev.css('display', 'none');
      $btnNext.css('display', 'none');

      if ($scrollElem.outerWidth() < $scrollElem.prop('scrollWidth')) {
        if ($scrollElem.scrollLeft() <= 0) {
          $btnPrev.css('display', 'none');
        } else {
          $btnPrev.css('display', 'flex');
        }

        // eslint-disable-next-line @stylistic/max-len
        if ($scrollElem.scrollLeft() + 1 >= $scrollElem.prop('scrollWidth') - $scrollElem.outerWidth()) {
          $btnNext.css('display', 'none');
        } else {
          $btnNext.css('display', 'flex');
        }
      }
    }

    $scrollElem.on('scroll', scrollHandler).trigger('scroll');

    if (!isTouchDevice) {
      $wrap.on('mousedown', 'td:not(.sticky-col)', mouseDownHandler);
    }

    // eslint-disable-next-line no-undef
    jQuery(window).on('resize', scrollHandler);

    $btnNext.on('click', () => {
      $scrollElem.stop().animate({ scrollLeft: $scrollElem.scrollLeft() + $wrap.outerWidth() });
    });

    $btnPrev.on('click', () => {
      $scrollElem.stop().animate({ scrollLeft: $scrollElem.scrollLeft() - $wrap.outerWidth() });
    });
  });
}
